import type { RouteLocationRaw } from 'vue-router'

import { BOOKING_TYPE_APPOINTMENT } from '@/lib/consts.ts'

import type { DeeplinkMatch } from '../service'

export default function handleShowAppointment (match: DeeplinkMatch): RouteLocationRaw {
  const appointmentUid = match.appointmentUid

  return {
    name: 'calendar',
    ...(appointmentUid && {
      query: {
        appointment: `${BOOKING_TYPE_APPOINTMENT.toLowerCase()}-${appointmentUid}`,
        show_booking: true,
      },
    }),
  } as unknown as RouteLocationRaw
}
